export default {
  root: {
    // [defaultTheme.breakpoints.up("md")]: { minWidth: 360 },
  },
};
